<div class="flex h-full">
	<vb-lxp-timing-tower-full
		class="grow-1 mb-16"
		[activeClass]="'active-tower-item'"
		[selectedClasses]="selectedClasses()"
	></vb-lxp-timing-tower-full>
	@if (false) {
		<vb-lxp-panel
			[panelKey]="'map'"
			[defaultOpenState]="true"
			[panelClass]="'map-panel'"
			[panelHeaderClass]="'map-panel-header'"
		>
			<div header class="pr-14">
				<span>Mini-map</span>
			</div>
			<div body>
				<mini-map [track]="'cota.geojson'" [sampleGps]="'cota_sample_gps.geojson'"></mini-map>
			</div>
		</vb-lxp-panel>
	}
</div>
